export default {
      path: '/lvy-privacy-for-app',
      component: () => import('../LVYPrivacyPolicy/LVYPrivacyPolicy'),
      meta: {
        title: '青藤之恋隐私政策',
        designWidth:750,
        expireIn: '',
        axiosConfig: {
          baseURL: '',
          withCredentials: false,
          postContentType: 'JSON'
        }
      }
    }
